import _regeneratorRuntime from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Volumes/VANE/marciano/studio4x4-suzuki-ecommerce/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import CurrencyFilter from 'src/filters/currency';
import PhoneFilter from 'src/filters/phone';
import DateFilter from 'src/filters/date';
export default
/*#__PURE__*/
(function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref2) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref2.Vue;
            Vue.filter('currency', CurrencyFilter);
            Vue.filter('phone', PhoneFilter);
            Vue.filter('date', DateFilter);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();